// 德语
import deLocale from 'element-ui/lib/locale/lang/de'
const de = {
login:{
buttoo:{
    add:'add'
}
},
dialog:{
buttton:{
    close:'Schließen'
},
ReportError:{
      next:'Next',
 h1:'Report Errors allows users to communicate with us to solve any data issues and improve data quality.',
 li1:'If you find any data problems or have a question about this data',
 li2:'If you want to contribute company information to improve this data',
 li3:'If you choose not to disclose your own company information that you might consider private',
 li4:'If you have any constructive suggestions for us to improve services',
 h2:"All comments submitted are subject to data verification. Users must complete your own user profile as our representative may contact you for authentication and verification of your company any rights to represent your company."
},
},

Home:{
    Applications:'Applications',
  SearchCompanies:'Search Companies',
  SearchTrade:'Search Trade',
  SearchRisks:'Search Risks',
  SearchCountries:'Search Countries',
  SearchNews:'Search News',
  SearchLeads:'Search Leads',
 selectCountry:'Land auswählen',
 inputCompany:"Firmennamen eingeben",
  searchCompanyNum:"Suche nach über 500 Millionen Unternehmen in über 200 Ländern und Territorien",
 keWord:'Stichwort',
 firstWord:"Text (Worte von links)",
 search:'Suchen',
 homeSeachTitle:'Globales Geschäft im Fokus',
 homeTitleDetail:"CSI, ein datenbasiertes Research- und IT-Unternehmen, ist auf Kredite, Risiken und Big Data spezialisiert. Es bietet globalen Investoren und Geschäftsleuten digitale Tools und nutzt fortschrittliche Analysen und Algorithmen, um schnelle, visuelle Einblicke zu liefern und so fundiertere Entscheidungen zu ermöglichen.",
 phoneTitleDetail:"Um schnell Unternehmensinformationen zu suchen, anzuzeigen und abzurufen, können Sie auch die CSI-App auf Ihrem Smartphone nutzen.",
 IndustryAnalysis :'Industry Analysis',
BusinessAnalytics :'Business Analytics',
ImportExportData :'Import-Export Data',
CompanyNews :'Company News',
Sanctions :'Sanctions',
SearchLeads:"Search Leads",
BusinessIntelligence :'Business Intelligence',
CompanyIdentityVerification :'Company Identity Verification',
KYCSolutions :'KYC Solutions',
OwnershipPenetration :'Ownership Penetration',
CompanyFinancialAnalysis:'Company Financial Analysis',
CreditRatings :'Credit Ratings',
CreditReports :'Credit Reports',
ESGRatings :'ESG Ratings',
VendorScreening :'Vendor Screening ',
MarketResearch:'Market Research ' 
},
IndustryStatistics:{
    SubjectCompany:"Betreff Unternehmen",
    Country:"Land",
    Compare:"Vergleichen",
    Industry:"Branche",
    CompanyType:"Unternehmenstyp",
    CompanySize:"Unternehmensgröße",
    CompanyStatus:"Unternehmensstatus",
    YearsinBusiness:"Geschäftsdauer",
    CompanyRating:"Unternehmensbewertung"
},
ListofResults:{
  SelectCountry:'Select Country',
  ClearAll:'Clear All',
  SelectIndustry:'Select Industry',
  ListedCompany:'Listed Company',
  YearsinBusiness:'Years in Business',
   Sharethisinformation:'Share this information',
  Pleaseaddress:'Please enter one or more email address',
  Example:'Example',
  message:'message',
  pleaseleaveamessage:'please leave a message',
  Include:'',
  thisaddress:'this company name,ID,address',
  CSIwebsite:'CSI website',
  Update:'Update',
  Iftheavailable:'If the available online data is insufficient or outdated, you can click the “Update” button to request an instant update for a fresh investigated business credit report from our local networking investigators or credit reporting agencies. The cost for this update is 1 credit per company. The update report typically takes between 24 and 72 hours to be delivered.',
  Abusinesscredit :'A business credit report provides detailed information about the subject company’s identification data, registry records, shareholding structure, company history, management description, related companies, actual operations, trade references, financial data and analysis, official public information such as litigation records and sanctions, and credit analysis and assessment.',
  Searchcompanies:'Search more emails on other companies',
  Rowsperpage:'Rows per page',
     CountyCity:'County/City'

},
Toolbar:{
     Filter:"Filtern",
    Select:"Auswählen",
    Edit:"Bearbeiten",
    Sortby:"Sortieren nach",
    Collect:"Sammeln",
    Saved:"Gespeichert",
    Compare:"Vergleichen",
    Export:"Exportieren",
    Download:"Herunterladen",
    Update:"Aktualisieren",
    Reporterror:"Fehler melden",
    Share:"Teilen",
    ascending:'昇順',
    descending:'降順',
    Customfolder:'カスタムフォルダ'
},
AiZaba:{
whatareyousearchingfor:'what are you searching for',
CreditAnalyst:'Credit Analyst',
Assesses:"Assesses a company'screditworthiness,identifiesfinancial risks,ensuring secure transactionsthrough data analysis andcredit ratings.",
LegalAdvisor:"Legal Advisor",
Provides:'Provides compliance guidance,reviews contracts,andassesseslegarisks to ensure businessoperations align with lawsand avoid disputes.',
BizConsultant:'Biz Consultant',
Optimizes:'Optimizes supply chains,identifiesbuyers, andboosts sales by analyzingmarket trends and offeringtailored strategies to improve efficiency',
EconomicAnalyst:'Economic Analyst',
Analyzes:"Analyzes industry and regional economic trendshelping businesses makeinformed decisions, and staycompetitive."
},
ContentTabs:{
    Background:"Hintergrund",
    BusinessActivities:"Geschäftstätigkeit",
    Performance:"Performance",
    Publications:"Publikationen",
    CreditOpinion:"Kreditgutachten",
    MarketAnalysis:"Marktanalyse",
    Snapshot:"Kurzfassung",
    Profile:"Profil",
    Ownership:"Eigentümerschaft",
    RelatedCompanies:"Verbundene Unternehmen",
    Management:"Management",
    Operations:"Geschäftstätigkeit",
    Locations:"Standorte",
    Industry:"Branche",
    ImportExport:"Import & Export",
    SupplyChain:"Lieferkette",
    FinancialHighlights:"Finanzielle Highlights",
    RatioAnalysis:"Kennzahlenanalyse",
    IndustryNorm:"Branchennorm",
    News:"News",
    Sanctions:"Sanktionen",
    IndustryStatistics:"Branchenstatistik",
    RatingAnalysis:"Ratinganalyse",
    CompetitiveAnalysis:"Wettbewerbsanalyse"
},
navigationBar:{
Notifications:'Benachrichtigungen',//通知
MarkasRead:'Als gelesen markieren',//标记已读
Viewall:'Alle anzeigen',//查看全部
SilverSubscriber:'Silber-Abonnent',//银级用户
Silversubscriberdate:'Ablaufdatum des Silber-Abonnements',//银级到期日
GoldSubscriber:'Gold-Abonnent',//金级用户
Goldsubscriptiondate:'Ablaufdatum des Gold-Abonnements',//金级到期日
AvailableCredits:'Verfügbare Credits',//可用积分
AddCredits:'Credits hinzufügen',//购买积分
IndivdualAccount:'Einzelkonto', //个人账号
GroupAccount:'Gruppenkonto' //集团账号

},
Snapshot:{
    CompanyDQIdesc:"The Data Quality Index (DQI) employs algorithms to assess different aspects of data, including completeness, validity, reliability of sources, consistency, timeliness, and bilingual support.The index is designed to assess the quality of data on a scale of 1 to 100, with higher scores indicating superior data quality. Algorithms can analyze data based on predefined rules or criteria, enabling objective and standardized measurements.Our Data Quality Index (DQI) serves as a reliable indicator, allowing users to quantitatively assess data quality. This enables data-driven decision-making and enhances the overall value and utility of the data.",
  CountryDQIdesc:"The Data Quality Index (DQI) assesses the reliability, accuracy, and accessibility of data across countries, reflecting differences in digital infrastructure, governance, and transparency. Developed nations typically rank higher due to strong data systems, open policies, and advanced technology, while developing economies often struggle with gaps in infrastructure, regulation, or data-sharing practices. Key factors include government transparency, data protection laws, and technological adoption. A high DQI enables better policymaking and business decisions, while a low score highlights areas needing investment.",
  CompanyDQI:'Firmen-DQI',//公司数据质量指数 DQI
  CountryDQI:'Länder-DQI',//国家数据质量指数 DQI
  Address:'Adresse',//地址
  CountyCity:'Landkreis/Stadt',//县/市
  ProvinceState:'Provinz/Bundesland',//省/州
  CountryRegion:'Land/Region',//国家/地区
  ZipCode:'Postleitzahl',//邮政编码
  Website:'Website',//网站
  Email:'E-Mail',//电邮
  Tel:'Tel.',//电话
  LastUpdate:'Letzte Aktualisierung',//最近更新
  DataSource:'Datenquelle',//数据来源
  LegalStatus:'Rechtsform',//法定状况
  CoID:'Firmen-ID',//公司ID
  CompanyType:'Firmentyp',//公司类型
  RegistrationDate:'Registrierungsdatum',//注册日期
  RegistrationStatus:'Registrierungsstatus',//注册状态
  Listed:'Börsennotiert',//上市信息
  CurrentOpperations:'Aktuelle Geschäftstätigkeit',//经营状况
  IndustryCode:'Branchencode',//行业代码
  BusinessActivities:'Geschäftstätigkeit',//主营业务
  NoofEmployees:'Anzahl der Mitarbeiter',//员工数量
  NoofShareholders:'Anzahl der Aktionäre',//股东数量
  Management:'Management',//管理状况
  Performance:'Leistung',//业绩表现
  Revenue:'Umsatz',//收入
  Assets:'Vermögen',//资产
  ProfitLoss:'Gewinn/Verlust',//利润
  Growth:'Wachstum',//公司增长
  Competitiveness:'Wettbewerbsfähigkeit',//竞争力
  CreditOpinion:'Kreditauskunft',//信用状况
  CreditRating:'Kreditrating',//信用评级
  CreditScore:'Kredit-Score',//信用评分
  ESGRating:'ESG-Rating',//ESG 评级
  Solvency:'Solvenz',//偿还能力
  Sanctions:'Sanktionen',//全球制裁
},
Profile:{
  CompanyProfile:'Firmenprofil',//基本资料
  CompanyName:'Firmenname',//公司名称
  NativeName:'Firmenname',//当地名称
  CompanyID:'Firmen-ID',//公司 ID
  VATNumber:'Umsatzsteuer-Identifikationsnummer',//VAT号
  StockCode:'Aktiencode',//股票代码
  Listed:'Börsennotiert',//上市日期
  RegistrationDate:'Registrierungsdatum',//注册日期
  LegalForm:'Rechtsform',//公司性质
  CompanyType:'Unternehmensart',//公司类型
  LegalStatus:'Rechtsstatus',//注册状态
  Jurisdiction:'Gerichtsbarkeit',//司法管辖区
  RegisteredAddress:'Registrierte Adresse',//注册地址
  ProvinceState:'Provinz/Bundesland',//省/州
  CountryRegion:'Land/Region',//国家/地区
  ZipCode:'Postleitzahl',//邮政编码
  OperatingAddress:'Geschäftsadresse',//经营地址
  LastUpdate:'Letzte Aktualisierung',//最近更新
  DataSource:'Datenquelle',//数据来源
  History:'Historie',//历史记录
    RegisteredCapital:'Registered Capital',
  PaidinCapital:'Paid-in Capital',
       CountyCity:'County/City'
},
Ownership:{
 UltimateBeneficiary:'Endbegünstigter',//最终受益人
  InvolvingIndividuals:'Personen',//涉及自然人股东
  InvolvingEnterprises:'Unternehmen',//涉及法人股东
  ShareholderLevel:'Gesellschafterebene',//股东层级x
  Name:'Name',//名称
  Country:'Land',//国家/地区
  Location:'Standort',//地点
  Type:'Art',//类型
  Shares:'Aktien',//股份
  Relation:'Verhältnis',//关系
    Individuals :'Individuals',//关系
        PartiesInvolved:'Parties Involved',
  RelatedCompany:'Related Company',
  CompanyShareholders:'Company Shareholders',
  NGOShareholders:'NGO Shareholders',
  NaturalPersonShareholder:'Natural Person Shareholder',
  SubjectInvestments:"Subject's Investments"
},
RelatedCompanies:{
 Total:'Gesamt',//相关公司总计
  Entities:'Unternehmen',//法人实体
  Countries:'Länder',//国家/地区
  Branches:'Niederlassungen',//分支机构
  RelatedComp:'Verbundene Unternehmen',//关联公司
  Name:'Name',//名称
  Country:'Land',//国家/地区
  Location:'Standort',//地点
  Type:'Art',//类型
  Relation:'Beziehung',//关系
  BranchOffices:'Branch Offices',
  Individuals:'Individuals',
},
Management:{
  Total:'Management',//管理层
  ContactInfo:'Kontaktinformationen',//联系人信息
  Countries:'Länder',//国家/地区
  Name:'Name',//名称
  Position:'Position',//职位
  Department:'Abteilung',//部门
  Country:'Land',//国家/地区
  ShareholderNot:'Aktionär oder nicht',//是否股东
  Relation:'Beziehungen',//关系
  Verification:'Verifizierung',//已验证
  Searchmoreemails:'Weitere E-Mails suchen',//搜索更多电邮
  Roles:'Rollen',//角色
  EducationLevel:'Bildungsniveau',//教育程度
  Phone:'Telefon',//电话
  Email:'E-Mail',//电邮
  Verified:'Verifiziert',//已验证
  Searchmore:'Weitere E-Mails anderer Unternehmen suchen',//搜索更多其他公司的电邮
},
Operations:{
    Operations:'Operations',
  LineofBusiness:'Geschäftszweig',//业务范围
  BusinessTerritories:'Geschäftsgebiete',//业务区域
  ImportExport:'Import & Export',//进出口信息
  Viewtradeinfo:'Weitere Handelsinformationen anzeigen',//查看更多贸易信息
  ProductsServices:'Produkte/Dienstleistungen',//产品/服务
  Products:'Produkte',//产品
  ProductImage:'Produktbild',//产品图片
  ProductName:'Produktname',//产品名称
  ProductDescription:'Produktbeschreibung',//产品描述
  Details:'Details',//详情
  Addproductinformation :'Produktinformationen hinzufügen',//添加产品信息
},
Locations:{
   Locations:"Locations",
  CoName:'Firmenname',//业务范围
  Relationship:'Beziehung',//关系
  Country:'Land',//国家/地区
  Location:'Standort',//地点
  Address:'Adresse',//地址
  Edit:'Bearbeiten',//编辑
  CompanyLocatiionsMap:'Firmenstandorte auf Karte',//地图中的公司位置
  Selectaddresstype:'Adresstyp auswählen',//选择地址类型
  Subjectcompany:'Unternehmen',//目标公司
  Subsidiary:'Tochtergesellschaft',//子公司
  RegisteredAddress :'Eingetragene Adresse',//注册地址
  OperationAddress :'Betriebsadresse',//运营地址
  All :'Alle',//全部
},
Industry:{
  IndustryTitle:'Branchenbezeichnung',//IndustryTitle
  IndustryDescription:'Branchenbeschreibung',//IndustryDescription
  ISIC:'ISIC',//ISIC
  ISICDescription:'ISIC-Beschreibung',//ISICDescription
  NACE:'NACE',//NACEDescription
  NACEDescription:'NACE-Beschreibung',//NACEDescription
  NAICS:'NAICS',//NAICS
  NAICSDescription:'NAICS-Beschreibung',//NAICSDescription
  CSIC:'CSIC',//CSIC, 
  CSICDescription:'CSIC-Beschreibung',//CSICDescription
  AAAIC:'AAAIC',//AAAIC
  AAAICDescription :'AAAIC-Beschreibung',//AAAICDescription
  GICS :'GICS',//GICS
  GICSDescriptio :'GICS-Beschreibung',//GICS 描述
},
ImportExport:{
  TotalImportAmount:'Gesamtimportmenge',//进口总额
  TopImportCountry:'Hauptimportland',//最大进口国家/地区
  TopImportProduct:'Hauptimportprodukt',//最大进口产品
  TotalExport:'Gesamtexport',//出口总额
  TopExportCountry:'Hauptexportland',//最大出口国家/地区
  TopExportProduct:'Hauptexportprodukt',//最大出口产品
  TradeVolume:'Handelsvolumen',//贸易额
  ImportShipments:'Importsendungen',//进口量
  ExportShipments:'Exportsendungen',//出口量
  ImportCountries:'Importländer',//进口国家/地区
  ExportCountries:'Exportländer',//出口国家/地区
  ImportVolume:'Importvolumen',//进口量
  ExportVolume:'Exportvolumen',//出口量
  TopSuppliers:'Hauptlieferanten',//主要供应商
  ByNumberofShipments:'Nach Anzahl der Sendungen',//按出货量
  TopBuyers:'Hauptkäufer',//主要买家
  ByNumberofShipments:'Nach Anzahl der Sendungen',//按出货量
  ImportQuantity:'Importmenge',//进口数量
  IncreaseDecreasexRate:'Zunahme-/Abnahmerate',//增/减率
  ExportQuantity:'Exportmenge',//出口数量
  ImportsExportsRecords:'Import- und Exportaufzeichnungen',//进出口记录
  Date:'Datum',//日期
  Product:'Produkt',//产品
  HSCode:'HS-Code',//HS 编码
  BuyerName:'Käufername',//买家名称
  Destination:'Bestimmungsort',//目的地
  SupplierName:'Lieferantname',//供应商名称
  Origin:'Herkunft',//原产地
  Amount:'Betrag',//金额
  Details:'Details',//详情
},
 FinancialHighlight:{
    ProfitabilityRatios:'Profitability Ratios',
  OperatingRatios:'Operating Ratios',
  StructuralRatios:'Structural Ratios',
ProductivityRatios:'Productivity Ratios',
GrowthRatios:'Growth Ratios',
  Revenue:'Revenue',//收入
  Profit:'Profit',//利润
  Growth:'Growth',//增长
  Liquidity:'Liquidity',//现金流状况
  FinancialStructure:'Financial Structure',//融资结构
  CreditOpinion:'Credit Opinion',//信用评估
  RiskIndicator :'Risk Indicator ',//风险指标
  Solvencyindex:'Solvency index',//偿还指数
  Year:'Year',//年份
  Change:'Change',//变化
  FinancialHighlights:'Finanzdaten der verbundenen Unternehmen',//关联公司财务数据
  FinancialHighlightsTitle:'Finanzielle Highlights der verbundenen Unternehmen',//关联公司财务摘要
  CompanyName:'Firmenname',//公司名称
  CompanyID:'Firmen-ID',//公司ID
  Country:'Land',//国家/地区
  CompanyStatus:'Firmenstatus',//公司状态
  Relations:'Beziehungen',//关系
  RatioAnalysis:'Kennzahlenanalyse der verbundenen Unternehmen' //关联公司比率分析
},
IndustryNorms:{
    IndustryStatistics:"Branchenstatistik",
    ofcompaniesintheIndustry:"Anzahl der Unternehmen in der Branche",
    oflistedCompaniesintheIndustry:"Anzahl der börsennotierten Unternehmen in der Branche",
    oflargecompaniesintheIndustry:"Anzahl der Großunternehmen in der Branche",
    ofSMEsintheIndustry:"Anzahl der KMU in der Branche",
    ofcompaniesinsample:"Anzahl der Unternehmen in der Stichprobe",
    ofcompaniesinloss:"Anzahl der Unternehmen mit Verlust",
    Observations:"Beobachtungen",
    AverageValue:"Durchschnittswert",
    MedianValue:"Medianwert",
    MaximumValue10:"Maximalwert 10 %",
    MinimumValue10:"Minimalwert 10 %",
    SubjectCompany:"Betroffenes Unternehmen",
    YearsinBusiness:"Geschäftsjahre",
    TotalAssets:"Bilanzsumme",
    TotalEquity:"Eigenkapital",
    Revenue:"Umsatz",
    NetEarning:"Nettogewinn",
    Returnonassets:"Kapitalrendite",
    Performance:"Leistung",
    ProfitabilityRatios:"Rentabilitätskennzahlen",
    Returnonequity:"Eigenkapitalrendite",
    Returnonassets:"Kapitalrendite",
    Grossmargin:"Bruttogewinnspanne",
    OperatingRatios:"Betriebskennzahlen",
    Stockturnover:"Lagerumschlag",
    Accountsreceivableturnover:"Debitorenumschlag",
    Assetsturnover:"Vermögensumschlag",
    Totalassetturnover:"Gesamtvermögensumschlag",
    StructuralRatios:"Strukturkennzahlen",
    Currentratio:"Aktuelle Kennzahl",
    Quickratio:"Quick ratio",
    Shareholdersliquidityratio:"Liquiditätsquote",
    GrowthRatios:"Wachstumskennzahlen",
    Salesgrowthrate:"Umsatzwachstumsrate",
    Netprofitgrowthrate:"Nettogewinnwachstumsrate",
    Totalassetsgrowthrate:"Bilanzwachstumsrate"
},
 News:{
  Date:'Datum',//日期
  Title:'Titel',//标题
  Source:'Quelle',//来源
  Impact:'Auswirkung',//影响
  Searchcompanies:'Weitere Nachrichten zu anderen Unternehmen suchen',//国家/地区
},
 Sanctions:{
  Potentialcompliance:'Es wurden potenzielle Compliance-Risiken erkannt.',//检测到潜在合规风险
  SeachbuttonNo:'Es wurden keine negativen Auswirkungen auf dieses Unternehmen festgestellt.',//未检测到任何与该公司相关的不良记录
  SeachbuttonYes:'Um weitere Sanktionsaufzeichnungen zu suchen, klicken Sie bitte auf „Sanktionen suchen“.',//要搜索更多制裁记录，请点击“搜索制裁”按钮。
  SearchSanctions:'Sanktionen suchen',//搜索制裁
  ViewDetails:'Details anzeigen',//查看详情
  Sanctions:'Sanktionen',//制裁
  Potentialcompliancerisks:'Potenzielle Compliance-Risiken',//潜在合规风险
  IDInfo:'ID-Informationen',//ID 信息
  IDType:'ID-Typ',//ID 类型
  IDDescription:'ID-Beschreibung',//ID 描述
  SanctionList:'Sanktionsliste',//制裁名单
  SanctionListInvolved:'Betroffene Sanktionsliste',//涉及的制裁名单
  StartDate:'Startdatum',//生效日期
  EndDate:'Enddatum',//结束日期
  SourceList:'Quellenliste',//来源名单
  SourceName:'Quellenname',//来源名称
  ProfileNotes:'Profilnotizen',//主体资料
  Link:'Link',//链接
},
CreditOpinion:{
    CreditAssessment:"Bonitätsprüfung",
    CreditAssessmentfromtheRelatedCompanies:"Bonitätsprüfung der verbundenen Unternehmen",
    Year:"Jahr",
    CreditRating:"Bonitätsrating",
    LocalCreditScore:"Lokale Bonitätsbewertung",
    ProbabilityofDefault:"Ausfallwahrscheinlichkeit",
    SolvencyIndex:"Bonitätsindex",
    CreditLine:"Kreditrahmen",
    RiskIndicator:"Risikoindikator",
    RelatedCreditAssessment:"Verwandte Bonitätsprüfung",
    CompanyName:"Firmenname",
    CompanyID:"Firmen-ID",
    Country:"Land",
    CompanyStatus:"Firmenstatus",
    Relations:"Beziehungen"
},
RatingAnalysis:{
    IndustyAnalysis:"Branchenanalyse",
    GeographicAnalysis:"Geografische Analyse",
    CompanyTypeAnalysis:"Unternehmenstypanalyse",
    BiusinessScaleAnalysis:"Skalenanalyse",
    HistoryAnalysis:"Historische Analyse",
    NormalDistribution:"Normalverteilung",
    SubjectCompany:"Unternehmen",
    Probabilityofthesubjectratinginitsindustry:"Wahrscheinlichkeit der Bewertung des Unternehmens in seiner Branche",
    Maximum:"Maximal 10 %",
    Mean:"Mittelwert",
    Average:"Durchschnitt",
    Minimum:"Minimum 10 %",
    RatingDistribution:"Bewertungsverteilung",
    Revenue:"Umsatz",
    Earning:"Ertrag",
    TotalAssets:"Bilanzsumme",
    Subjectratinginitsindustrybyfinancialindicators:"Bewertung des Unternehmens in seiner Branche nach Finanzkennzahlen",
    Best:"Beste",
    Worst:"Schlechteste",
    Rankingofsubject:"Ranking der Bewertung des Unternehmens in der Branche",
    Industy:"Branche",
    Percentilerank:"Perzentilrang: Prozentsatz der Unternehmen, die die Bewertung des Unternehmens erreicht oder unterschritten haben",
    Historicaldevelopmentofsubject:"Historische Entwicklung der Bewertung des Unternehmens in seiner Branche",
    IndustryAverage:"Branchendurchschnitt",
    SubjectRatingChanges:"Änderungen der Bewertung des Unternehmens"
},
CompetitiveAnalysis:{
    MarketPosition:"Marktposition",
    Revenus:"Umsatz",
    NetEarnings:"Nettogewinn",
    NetAssets:"Nettovermögen",
    TotalAssets:"Gesamtvermögen",
    Employees:"Mitarbeiter",
    Mean:"Mittelwert",
    Average:"Durchschnitt",
    Maximum:"Maximum (10 %)",
    Worst:"Schlechtestes (10 %)",
    Subjectcompany:"Vergleichsunternehmen",
    PerformanceComparison:"Leistungsvergleich",
    ProfitabilityRatios:"Rentabilitätskennzahlen",
    Grossmargin:"Bruttomarge",
    Returnonassets:"Kapitalrendite",
    Returnonequity:"Eigenkapitalrendite",
    Average:"Durchschnitt",
    OperatingRatios:"Betriebskennzahlen",
    Stockturnover:"Lagerumschlag",
    Assetsturnover:"Kapitalumschlag",
    Collectionperiod:"Erfassungszeitraum",
    GrowthRatios:"Wachstumskennzahlen",
    Totalassetsgrowthrate:"Wachstumsrate des Gesamtvermögens",
    Salesgrowthrate:"Umsatzwachstumsrate",
    Netprofitgrowthrate:"Wachstumsrate des Nettogewinns",
    StructuralRatios:"Strukturkennzahlen",
    Debtratio:"Verschuldungsgrad",
    Quickratio:"Quick ratio",
    Currentratio:"Aktuelle Kennzahl"
},
AccountCenterMenu:{
SearchinSettings:"Suche in den Einstellungen",//在“设置”中搜索
Account:"Konto",//账户
MyAccount :"Mein Konto",//我的账户
ContactInfo:"Kontaktdaten",//联系信息
AccountSecurity:"Kontosicherheit",//账户安全
OrganizationalManagement:"Organisationsverwaltung",//组织管理
UserGroup:"Benutzergruppe",//用户组
User:"Benutzergruppe",//用户
Role:"Rolle",//角色
MyDatabase:"Meine Datenbank",//我的数据库
MyUsage:"Meine Nutzung",//我的使用情况
CompaniesViewed:"Angesehene Unternehmen",//查看过的公司
ReportsDownloaded:"Heruntergeladene Berichte",//下载的报告
ReportUpdatesOrdered:"Bestellte Berichtsaktualisierungen",//订购的报告更新
BillingandPayment:"Rechnungsdatensätze",//账单和付款
BillRecords:"Rechnungsdatensätze",//账单记录
PaymentRecords:"Gutschriften",//付款记录
CreditDeductions:"Gutschriften",//信用扣款
InvoicesDownloaded:"Heruntergeladene Rechnungen",//下载的发票
UserSettings:"Benutzereinstellungen",//用户设置
Messages:"Nachrichten",//消息
Notifications:"Benachrichtigungen",//通知
HelpCenter:"Hilfe",//帮助中心
FAQ:"FAQ",//常见问题
Privacy:"Datenschutz",//隐私
Terms:"Nutzungsbedingungen",//条款
ReportIssues:"Probleme melden",//报告问题
UserGuide:"Benutzerhandbuch",//用户指南
AboutCSI:"Über CSI"//关于CSI


},
MyAccount:{
Logintime:'登录时间',//登录时间
SignOut:'退出',//退出
DeleteAccount:'删除账户',//删除账户
AccountID:'账户ID',//账户ID
Enteranewaddress:'输入新的电邮',//输入新的电邮
EnterVerificationCode:'输入验证码',//输入验证码
SendverificationCode:'发送验证码',//发送验证码
Password:'密码',//密码
Originalpassword:'原始密码',//原始密码
Newpassword:'新密码',//新密码
Confirmnewpassword:'确认新密码',//确认新密码
AccountOwnership:'账户所有权',//账户所有权
IndividualAccount:'个人账户',//个人账户
GroupAccount:'集团账户',//集团账户
Organizationname:'机构名称',//机构名称
CountryRegion:'国家/地区',//国家/地区
Address:'地址',//地址
City:'城市',//城市
ZipCode:'邮政编码',//邮政编码
FirstName:'名字',//名字
LastName:'姓氏',//姓氏
PhoneNumber:'电话号码',//电话号码
Email:'电邮',//更改
Change:'更改',//更改
Save:'保存',//保存
Cancel:'取消',//取消
LastLogin:'Last Login',//Last Login
RecentLogin:'登录尝试次数',//登录尝试次数
AverageLoginTime:'平均登录时间',//平均登录时间
TotalLoginAttempts:'登录尝试次数',//登录尝试次数

},
ShippingOrderDetails:{
    Date:"Datum",
    MasterBillofLading:"Master-Ladeschein",
    Source:"Quelle",
    BillNo:"Ladescheinnummer",
    ImporterBuyer:"Importeur/Käufer",
    ExporterSeller:"Exporteur/Verkäufer",
    Name:"Name",
    Address:"Adresse",
    Country:"Land",
    Contact:"Kontakt",
    Email:"E-Mail",
    CargoInfo:"Frachtinformationen",
    HSCode:"HS-Code",
    Quantity:"Menge",
    WeightUnit:"Gewichtseinheit",
    ProductDescription:"Produktbeschreibung",
    Amount:"Betrag",
    QuantityUnit:"Mengeneinheit",
    Weight:"Gewicht",
    HSDescription:"HS-Bezeichnung",
    Incoterms:"Incoterms",
    ShippingInfo:"Versandinformationen",
    Vessel:"Schiff",
    Consignee:"Empfänger",
    MeansofTransport:"Transportmittel",
    CountryofOrigin:"Ursprungsland",
    Voyage:"Reise",
    Notifier:"Melder",
    CountryofDestnation:"Bestimmungsland",
    AddressofOrigin:"Ursprungsadresse",
    Shipper:"Versender",
    AddressofDestnation:"Bestimmungsadresse",
    Container:"Container",
    ContainerID:"Container-ID",
    ContainerType:"Containertyp",
    ContainerDescDode:"Containerbeschreibung",
    ContainerSize:"Containergröße"
},
ReportIssues:{
    Whattypeoferrorsyouarereporting:"Welche Art von Fehlern melden Sie?",
    Tellusmoreaboutyourproblems:"Erzählen Sie uns mehr über Ihre Probleme.",
    Wouldyouliketoprovideascreenshotorafileregardingyourproblem:"Möchten Sie einen Screenshot oder eine Datei zu Ihrem Problem bereitstellen?",
    Fillinyourcontactinformation:"Geben Sie Ihre Kontaktdaten ein:",
    FirstName:"Vorname",
    LastName:"Nachname",
    PhoneNumber:"Telefonnummer",
    Email:"E-Mail"
},
UserSettings:{
    LanguageandLocation:"Sprache und Standort",
    Language:"Sprache",
    Selectyourpreferedlanguage:"Wählen Sie Ihre bevorzugte Sprache",
    Location:"Standort",
    Selectyourlocation:"Wählen Sie Ihren Standort",
    NotificationSetting:"Benachrichtigungseinstellungen",
    EmailNotification:"E-Mail-Benachrichtigung",
    ServiceUpdates:"Service-Updates",
    CompanyNews:"Unternehmensnachrichten"
},
ContactInfo:{
    ContactInfo:"Kontaktinformationen",
    FirstName:"Vorname",
    LastName:"Nachname",
    PhoneNumber:"Telefonnummer",
    Email:"E-Mail",
    CountryRegion:"Land/Region",
    AddressLine:"Adresszeile",
    City:"Ort",
    ZipCode:"Postleitzahl",
    Alternativecontactperson:"Alternativer Ansprechpartner",
    Setascontactperson:"Als Ansprechpartner festlegen",
    Edit:"Bearbeiten"
},
AccountSecurity:{
    Setupmysecurityquestions:"Sicherheitsfragen einrichten",
    Pleasechooseaquestion:"Bitte wählen Sie eine Frage aus",
    Pleaseentertheanswertothequestion:"Bitte geben Sie die Antwort auf die Frage ein",
    SessionTimeoutAutomaticLogoutSettings:"Sitzungs-Timeout: Automatische Abmeldung",
    Thesystemwillautomatically:"Das System meldet Sie nach einer gewissen Zeit der Inaktivität automatisch ab. Die Standard-Timeout-Dauer beträgt 5 Minuten, Sie können diese jedoch nach Bedarf anpassen."
},
MyDatabase:{
    TotalNumberofCompaniesSearched:"Gesamtzahl der gesuchten Unternehmen",
    TotalNumberofCompaniesCollected:"Gesamtzahl der erfassten Unternehmen",
    TotalNumberofUpdateReportsOrdered:"Gesamtzahl der bestellten Update-Berichte",
    Date:"Datum",
    UserName:"Benutzername",
    CompanyName:"Firmenname",
    Status:"Status",
    UsageType:"Nutzungsart",
    Entercompanyname:"Firmenname eingeben",
    Download:"Herunterladen"
},
OrganizationalManagement:{
    GroupName:"Gruppenname",
    ParentGroupName:"Name der übergeordneten Gruppe",
    Organization:"Organisation",
    GroupID:"Gruppen-ID",
    GroupStatus:"Gruppenstatus",
    Operation:"Operation",
    NewlyBuilt:"Neu erstellt",
    UserAccount:"Benutzerkonto",
    Role:"Rolle",
    AccountStatus:"Kontostatus",
    RoleName:"Rollenname",
    Position:"Position",
    RoleStatus:"Rollenstatus",
    Valid:"Gültig",
    Invalid:"Ungültig",
    PermissionSettings:"Berechtigungseinstellungen"
},
BillingandPayment:{
    TotalNumberofOrders:"Gesamtzahl der Bestellungen",
    TotalPaymentAmount:"Gesamtzahlungsbetrag",
    TotalDeductionCredits:"Gesamtabzugsgutschriften",
    Date:"Datum",
    UserAccount:"Benutzerkonto",
    CompanyName:"Firmenname",
    OrderNo:"Bestellnummer",
    OrderType:"Bestellart",
    OrderStatus:"Bestellstatus",
    Download:"Herunterladen",
    PaymentAmount:"Zahlungsbetrag",
    Contactus:"Kontakt",
    DownloadInvoice:"Rechnung herunterladen",
    CreditsDeducted:"Abgezogene Gutschriften",
    ReportOrderStatus:"Bestellstatus melden",
    CompanyID:"Firmennummer",
    CountryRegion:"Land/Region",
    AddressLine:"Adresszeile",
    City:"Ort",
    ZipCode:"Postleitzahl",
    FirstName:"Vorname",
    LastName:"Nachname",
    PhoneNumber:"Telefonnummer",
    Email:"E-Mail",
    BankAccountHolderName:"Kontoinhaber",
    BeneficiaryBankName:"Name der Empfängerbank",
    SWIFTCODE:"SWIFT-CODE",
    AccountNumber:"Kontonummer",
    BeneficiaryBankAddress:"Adresse der Empfängerbank",
    ABA:"ABA (Bankleitzahl)",
    IBANnumber:"IBAN-Nummer"
},
JiuGuoge:{
  Country:'Country',
  Industry:'Industry',
  CoSize:'Co. Size',
  Liquidity:'Liquidity',
  NoofcoinIndustry:'No. of co. in Industry',
  IndustryRating:'Industry Rating',
  Profitability:'Profitability',
  Growth:'Growth',
  FinancialStructurt:'Financial Structurt',
  Repaying:'Repaying',
},
  ...deLocale
}

export default de